import React from 'react';
import Container from 'container';
import Headline from 'headline';
import Button from 'button';
import Img from 'img';
import s from './text-image-flip-b.module.scss';

export default function textImageFlipB({
  title,
  paragraphs,
  button,
  image,
  background_image
}) {
  return (
    <Container className={s.section}>
      <div className={s.wrapper}>
        <Img className={s.bgImg} src={background_image?.title} />
        <div className={s.content}>
          <div className={s.imgTitleWrapper}>
            <Headline
              className={s.title}
              h1
              wild
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <Img className={s.image} src={image?.title} alt={image?.title} />
          </div>
          <div className={s.textBtnWrapper}>
            {paragraphs.map(el => (
              <p
                className={s.text}
                dangerouslySetInnerHTML={{ __html: el.text }}
              />
            ))}
            <Button secondary className={s.button} href={button.href}>
              {button.button_text}
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
}
